import {useApiQuery, TypeWithEtag} from '@wallaby-ui/core';
import {MerieSchema} from '@wallaby-ui/document';
import {useMemo} from 'react';

interface UseChartEventsParams {
  startDate?: string | Date;
  endDate?: string | Date;
  hospitalizationId: string;
  encounterId: number | undefined;
  config: any;
}

interface UseChartEventsReturn {
  data: MerieSchema.components['schemas']['EncounterTimelineChartEventsDto'] | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export const useChartEvents = ({
  startDate,
  endDate,
  hospitalizationId,
  encounterId,
  config,
}: UseChartEventsParams): UseChartEventsReturn => {
  const chartEventParams = useMemo(() => {
    const params = {} as any;

    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    return params;
  }, [startDate, endDate]);

  const chartEventsUrl = useMemo(() => {
    return config?.service.url.hospitalizationChartEvents.replace('{id}', hospitalizationId);
  }, [config?.service.url.hospitalizationChartEvents, hospitalizationId]);

  const {
    data: chartEventsData,
    isLoading: chartEventsLoading,
    isError: chartEventsError,
    refetch: chartEventsRefetch,
  } = useApiQuery<MerieSchema.components['schemas']['EncounterTimelineChartEventsDto']>([chartEventsUrl, encounterId], null, {
    axiosConfig: {
      url: chartEventsUrl,
      params: new URLSearchParams(chartEventParams),
    },
  });

  return {
    data: chartEventsData,
    isLoading: chartEventsLoading,
    isError: chartEventsError,
    refetch: chartEventsRefetch,
  };
};
